import React from 'react';
import VersusSettings from './VersusSettings';
import MainSettings from './MainSettings';

/**
 * Renderiza el bloque SettingsDrawer de SCAPP V2.
 *
 * @param {object} props
 * @param {object} props.v - Modelo de presentación y callbacks del panel.
 * @returns {React.ReactNode} Bloque visual sin estado local.
 */
export default function SettingsDrawer({
  v
}) {
  return v.drawerOn ? React.createElement(React.Fragment, null, v.text("\n  "), React.createElement("div", {
    "onClick": v.closeDrawer,
    style: {
      "position": "absolute",
      "inset": "0",
      "zIndex": "90",
      "background": "rgba(1,4,10,0.35)"
    }
  }, null), v.text("\n  "), React.createElement("aside", {
    style: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "bottom": "0",
      "width": "16.666667vw",
      "zIndex": "100",
      "background": "rgb(8,16,30)",
      "borderLeft": "0.052083vw solid rgba(232,80,20,0.3)",
      "boxShadow": "-1.481481vh 0 3.703704vh rgba(0,0,0,0.5)",
      "display": "flex",
      "flexDirection": "column",
      "overflow": "auto",
      "paddingBottom": "1.851852vh"
    }
  }, v.text("\n    "), React.createElement(VersusSettings, {
    v
  }), v.text("\n    "), React.createElement(MainSettings, {
    v
  }), v.text("\n  ")), v.text("\n  ")) : null;
}
